import { jsxs as n, jsx as c } from "react/jsx-runtime";
function d(h) {
  return /* @__PURE__ */ n(
    "svg",
    {
      version: "1.1",
      id: "Capa_1",
      xmlns: "http://www.w3.org/2000/svg",
      x: "428.067px",
      y: "428.067px",
      viewBox: "0 0 428.067 428.067",
      ...h,
      children: [
        /* @__PURE__ */ c("g", { children: /* @__PURE__ */ c("g", { children: /* @__PURE__ */ c(
          "path",
          {
            d: `M285.376,0c-0.142-0.001-0.284,0-0.426,0.003c-9.726-0.167-17.746,7.583-17.912,17.309
			c-0.003,0.183-0.003,0.366-0.001,0.549v41.142h36V17.861C303.092,8.052,295.185,0.056,285.376,0z`
          }
        ) }) }),
        /* @__PURE__ */ c("g", { children: /* @__PURE__ */ c("g", { children: /* @__PURE__ */ c(
          "path",
          {
            d: `M327.35,44.003h-8.313v23.222c0.084,4.211-3.261,7.694-7.473,7.778c-0.102,0.002-0.203,0.002-0.305,0h-52.622
			c-4.132,0.068-7.536-3.225-7.605-7.357c-0.002-0.14-0.001-0.281,0.005-0.421V44.003h-136v23.222
			c-0.136,4.421-3.823,7.9-8.245,7.778h-52.62c-4.379,0.113-8.02-3.344-8.134-7.723c0-0.018-0.001-0.037-0.001-0.055V44.003h-7.455
			C20.59,44.094,6.049,58.699,6.037,76.691v34.312h354V76.691C359.959,58.671,345.37,44.082,327.35,44.003z`
          }
        ) }) }),
        /* @__PURE__ */ c("g", { children: /* @__PURE__ */ c("g", { children: /* @__PURE__ */ c("path", { d: "M80.483,0.003c-10.097,0-18.446,7.763-18.446,17.858v41.142h37V17.861C99.037,7.766,90.579,0.003,80.483,0.003z" }) }) }),
        /* @__PURE__ */ c("g", { children: /* @__PURE__ */ c("g", { children: /* @__PURE__ */ c(
          "path",
          {
            d: `M6.037,127.003v218.913c0,17.941,14.6,33.087,32.545,33.087h148.231c-12.607-21.159-19.283-45.322-19.327-69.952
			c0-74.6,60.728-135.566,135.327-135.566c19.766,0.048,39.288,4.375,57.224,12.683v-59.165H6.037z`
          }
        ) }) }),
        /* @__PURE__ */ c("g", { children: /* @__PURE__ */ c("g", { children: /* @__PURE__ */ c(
          "path",
          {
            d: `M302.737,189.485c-65.883,0.001-119.29,53.41-119.289,119.293s53.41,119.29,119.293,119.289
			c65.882-0.001,119.289-53.409,119.289-119.291C421.956,242.923,368.59,189.558,302.737,189.485z M349.847,327.003h-53.622
			c-4.493-0.081-8.114-3.707-8.188-8.2v-70.16c0-4.418,3.582-8,8-8s8,3.582,8,8v62.36h45.81c4.418,0,8,3.582,8,8
			S354.265,327.003,349.847,327.003z`
          }
        ) }) })
      ]
    }
  );
}
export {
  d as EventIcon
};
